import { translate } from '../../../utils/GameEngine';
import { IconButton } from './IconButton';

export class ShareButton extends IconButton {
    constructor(callback?: () => any) {
        super(translate('Share', true) + '!', callback, 'facebook_button@2x', true, true, 1, 32);
    }

    protected initProperties(): void {
        super.initProperties();
        this.iconTexture = 'share_icon@2x';
        this.iconScale = 0.4;
        this.labelStyle.fill = 0xFFFFFF;
    }

    protected drawLayout(): void {
        super.drawLayout();
        this.icon.visible = false;
    }

    public updateLabel(text: string): void {
        super.updateLabel(text);
        this.label.x += 16;
        this.label.y -= 3;
    }
}